export default __webpack_public_path__ + "static/sells_real_time-feedc35aebeb3df81bbf8bf8b7e4a5de.png";